import { CSSProperties } from 'styled-components';

import { IconCloseSmall } from '@components/icons/close-small';
import { Tag } from '@components/tag';
import { useScopedTranslate } from '@locale/translate';
import { pxToRem } from '@utils/converters';

import { TravellerJourneyAction } from 'api/types';
import { MoreItems, TravellerNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { useFlowNodes } from 'ui/traveller-journey-builder/hooks/use-nodes';
import { NodeActions } from 'ui/traveller-journey-builder/node-types/common';
import { NodeContainer } from 'ui/traveller-journey-builder/node-types/node-container';
import { TravellerJourneyNode } from 'ui/traveller-journey-builder/node-types/types';

import { getConditionDescription, getConditionTooltip } from './description';
import { conditionGapSize } from './helpers';
import { useConditionDescription } from './hooks';

type ActionType = 'condition_v2';

export const actionCardStyles: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: conditionGapSize,
};
export const tagStyles: CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  width: pxToRem(136),
  marginTop: pxToRem(8),
};

export const getDescription = (action: TravellerJourneyAction<ActionType>): string => {
  return getConditionDescription({ values: action.values, styled: false }) as string;
};

export const Node = (node: TravellerJourneyNode<ActionType>) => {
  const { t } = useScopedTranslate(nodeLocale);
  useFlowNodes();

  const values = node.data?.values;

  const { descriptionText, isTextClamped } = useConditionDescription(values);
  const description = node.data?.description?.trim();
  const hasDescription = Boolean(description);

  return (
    <NodeContainer node={node}>
      <TravellerNodeActionCard
        cardStyles={actionCardStyles}
        node={node}
        label={t('title')}
        descriptionText={description || descriptionText}
        tooltip={!hasDescription ? getConditionTooltip({ values, isTextClamped }) : ''}
        renderBelowDescription={
          !hasDescription ? (
            <>
              <MoreItems items={values?.conditions} />
              {node.data.isHalted && node.data.isCompleted && (
                <Tag
                  size="large"
                  styles={tagStyles}
                  text={t('conditionNotMet')}
                  variant="indigo-trans-bg"
                  icon={<IconCloseSmall />}
                />
              )}
            </>
          ) : (
            ''
          )
        }
      >
        <NodeActions node={node} />
      </TravellerNodeActionCard>
    </NodeContainer>
  );
};

const nodeLocale = {
  en: {
    title: 'Condition',
    more: '{0} more ..',
    conditionNotMet: 'Condition not met',
  },
};
